import { render } from "./ServicesToggle.vue?vue&type=template&id=0b859970&scoped=true"
import script from "./ServicesToggle.vue?vue&type=script&lang=js"
export * from "./ServicesToggle.vue?vue&type=script&lang=js"

import "./ServicesToggle.vue?vue&type=style&index=0&id=0b859970&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b859970"]])

export default __exports__